export default __webpack_public_path__ + "static/media/blip-curious.0316fe72.svg";